import type React from "react";
import { GraphemeFontGlyph } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.grapheme.glyph.font";
import type { GraphemeGlyph } from "@-/dev.improve.haniverse.lib.morpheme.grapheme.entities";
import { View } from "@-/com.npmjs.react-native";

/**
 * The SVG glyphs' no-strokes state: the font glyph in the same footprint the strokes would occupy.
 * Rendered deliberately when the grapheme has no Hanzi Writer stroke data (`strokeList === null`),
 * or when the glyph has no codepoint to draw.
 */
export function GraphemeSvgGlyphFontFallback({
  color = null,
  fallback,
  glyph,
  showBackground,
  size,
}: {
  color?: string | null;
  fallback: React.ReactNode | undefined;
  glyph: GraphemeGlyph;
  showBackground: boolean;
  size: number;
}) {
  return (
    <View
      className={
        showBackground ? "overflow-hidden rounded-xs border border-border bg-surface" : undefined
      }
      pointerEvents="none"
    >
      <View
        className="items-center justify-center"
        pointerEvents="none"
        style={{ height: size, width: size }}
      >
        {fallback ?? (
          <GraphemeFontGlyph
            className="text-foreground"
            glyph={{ ...glyph, color }}
            style={{
              fontSize: Math.round(size * 0.62),
              lineHeight: Math.round(size * 0.62 * 1.2),
            }}
          />
        )}
      </View>
    </View>
  );
}
